define(
	'SA.ShopperApproved.ShopperApprovedModuleShopping', [
		'SA.ShopperApproved.ShopperApprovedModulePDPStars.View', 'SA.ShopperApproved.ShopperApprovedModulePDPWidget.View', 'Facets.ItemCell.View', 'SA.ShopperApproved.ShopperApprovedModulePLP.View', 'SA.ShopperApproved.ShopperApprovedModuleFooter.View', 'underscore', 'jQuery'
	],   
    function(
		ShopperApprovedModulePDPStarsView, ShopperApprovedModulePDPWidgetView, FacetsItemCellView, ShopperApprovedModulePLPView, ShopperApprovedModuleFooterView, _, jQuery
	) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                var pdp = container.getComponent("PDP");
                var plp = container.getComponent("PLP");
                var layout = container.getComponent('Layout');
                var self = this;
                if (pdp) {

                    pdp.addChildView('cms:item_info', function(tes) {
                        return new ShopperApprovedModulePDPStarsView({ container: container });
                    });

                    pdp.addChildView('ProductReviews.Center', function(tes) {
                        var iteminfo = pdp.getItemInfo();
                        var itemInternal = iteminfo.item
                        var view = this;

                        return new ShopperApprovedModulePDPWidgetView({ container: container, iteminfo: pdp.getItemInfo() });
                    });
                }


                /*if (plp) {
                        plp.addChildView('GlobalViews.StarRating', function() { 
                            return new GooglereviewintegrationPLPView({ container: container });
                        });
                    }*/
                /*if (plp) {
                        plp.addToViewContextDefinition('Facets.ItemCell.View', 'varforshopperapproved', 'string', function varforshopperapproved(context) {
                        var model = _.find(plp.getItemsInfo(), function(item) {

                            return item.internalid == context.itemId
                        });
                        plp.addChildView('GlobalViews.StarRating', function() { 
                        return new GooglereviewintegrationPLPView({ container: container,model:model});
                    });

                    });
                }*/

                if (plp) {
                    FacetsItemCellView.prototype.childViews['ItemDetails.Options'] = function(itemdetails) {
                        return new ShopperApprovedModulePLPView({
                            container: container,
                            model: itemdetails
                        });
                    };

                    jQuery('body').append(jQuery(
                        '<script type="text/javascript">' +
                        'function saLoadScript(src) {' +
                        'var js = window.document.createElement("script");' +
                        'js.src = src; js.type = "text/javascript";' +
                        'document.getElementsByTagName("head")[0].appendChild(js);}' +
                        'setTimeout(function(){ saLoadScript("//www.shopperapproved.com/widgets/group2.0/27282.js"); }, 3000);' +
                        '</script><style>div[data-view="GlobalViews.StarRating"] { display: none; } .star_container .ind_cnt { font-size: 12px; }</style>'
                    ));
                }

                if(layout) {
                    layout.addChildView('Footer', function () {
                        return new ShopperApprovedModuleFooterView({ container: container });
                    });
                }
            }
        };
});
